import { corporateConstants } from "./constants";

const initialState = {
  isLoadInner: false,
  isLoad: false,
  isLoadUpdate: false,
  message: null,
  loadErr: null,
  all_corporate_acounts: [],
  saved_item: null,
  charges: [],
  charges_load: false,
  data: [],
  contactList: [],
  contactLoad: false,
  addContactLoad: false,
  deleteContactLoad: false,
  enableContactLoad: false,
  updateLoad: false,
  paymentList: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // Loading
    case corporateConstants.LOAD:
      return {
        ...state,
        isLoad: true,
        loadErr: null,
      };
    case corporateConstants.LOAD_SUCCESS:
      return {
        ...state,
        isLoad: false,
        loadErr: null,
        message: action.message,
      };
    case corporateConstants.LOAD_FAIL:
      return {
        ...state,
        isLoad: false,
        loadErr: action.error,
        message: null,
      };

    case corporateConstants.GET_INVOICE_LOAD:
      return {
        ...state,
        charges_load: true,
        loadErr: null,
      };
    case corporateConstants.GET_INVOICE_SUCCESS:
      return {
        ...state,
        charges_load: false,
        loadErr: null,
        charges: action.data,
      };
    case corporateConstants.GET_INVOICE_FAIL:
      return {
        ...state,
        charges_load: false,
        loadErr: action.error,
        charges: [],
      };

    case corporateConstants.FLUSH_CONTACT:
      return {
        ...state,
        contactList: [],
      };

    case corporateConstants.GET_VERSIONS_LOAD:
      return {
        ...state,
        isLoad: true,
        loadErr: null,
      };
    case corporateConstants.GET_VERSIONS_SUCCESS:
      return {
        ...state,
        isLoad: false,
        loadErr: null,
        data: action.data,
      };
    case corporateConstants.GET_VERSIONS_FAIL:
      return {
        ...state,
        isLoad: false,
        loadErr: action.error,
      };
    case corporateConstants.ENABLE_CONTACT_LOAD:
      return {
        ...state,
        enableContactLoad: true,
        loadErr: null,
      };
    case corporateConstants.ENABLE_CONTACT_SUCCESS:
      return {
        ...state,
        enableContactLoad: false,
        loadErr: null,
      };
    case corporateConstants.ENABLE_CONTACT_FAIL:
      return {
        ...state,
        enableContactLoad: false,
        loadErr: action.error,
      };
    case corporateConstants.DELETE_CONTACT_LOAD:
      return {
        ...state,
        deleteContactLoad: true,
        loadErr: null,
      };
    case corporateConstants.DELETE_CONTACT_SUCCESS:
      return {
        ...state,
        deleteContactLoad: false,
        loadErr: null,
      };
    case corporateConstants.DELETE_CONTACT_FAIL:
      return {
        ...state,
        deleteContactLoad: false,
        loadErr: action.error,
      };
    case corporateConstants.ADD_CONTACT_LOAD:
      return {
        ...state,
        addContactLoad: true,
        loadErr: null,
      };
    case corporateConstants.ADD_CONTACT_SUCCESS:
      return {
        ...state,
        addContactLoad: false,
        loadErr: null,
        data: action.data,
      };
    case corporateConstants.ADD_CONTACT_FAIL:
      return {
        ...state,
        addContactLoad: false,
        loadErr: action.error,
      };

    case corporateConstants.UPDATE_CONTACT_LOAD:
      return {
        ...state,
        updateLoad: true,
        loadErr: null,
      };
    case corporateConstants.UPDATE_CONTACT_SUCCESS:
      return {
        ...state,
        updateLoad: false,
        loadErr: null,
        data: action.data,
      };
    case corporateConstants.UPDATE_CONTACT_FAIL:
      return {
        ...state,
        updateLoad: false,
        loadErr: action.error,
      };

    case corporateConstants.GET_CONTACT_LOAD:
      return {
        ...state,
        contactLoad: true,
        loadErr: null,
      };
    case corporateConstants.GET_CONTACT_SUCCESS:
      return {
        ...state,
        contactLoad: false,
        loadErr: null,
        contactList: action.data,
      };
    case corporateConstants.GET_CONTACT_FAIL:
      return {
        ...state,
        contactLoad: false,
        loadErr: action.error,
      };
    case corporateConstants.GET_PAYMENT_LIST_LOAD:
      return {
        ...state,
        isLoad: true,
        loadErr: null,
      };
    case corporateConstants.GET_PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        isLoad: false,
        loadErr: null,
        paymentList: action.paymentList,
      };
    case corporateConstants.GET_PAYMENT_LIST_FAIL:
      return {
        ...state,
        isLoad: false,
        loadErr: action.error,
      };
    case corporateConstants.INVOICE_FLUSH:
      return {
        ...state,
        charges_load: false,
        loadErr: "",
        charges: [],
      };

    case corporateConstants.UPDATE_VERSION_LOAD:
      return {
        ...state,
        isLoadUpdate: true,
        loadErr: null,
      };
    case corporateConstants.UPDATE_VERSION_SUCCESS:
      return {
        ...state,
        isLoadUpdate: false,
        loadErr: null,
      };
    case corporateConstants.UPDATE_VERSION_FAIL:
      return {
        ...state,
        isLoadUpdate: false,
        loadErr: action.error,
        message: null,
      };

    case corporateConstants.FLUSH:
      return {
        ...state,
        message: null,
      };
    case corporateConstants.FLUSH_ERROR:
      return {
        ...state,
        loadErr: null,
      };
    case corporateConstants.ALL_CORPORATE_ACCOUNTS:
      return {
        ...state,
        all_corporate_acounts: action.all_accounts,
        isLoadInner: true,
      };
    case corporateConstants.SAVE_CORPORATE_ACCOUNTS:
      return {
        ...state,
        saved_item: action.save_item,
      };
    case corporateConstants.UPDATE_PRICE_LOAD:
      return {
        ...state,
        isLoad: true,
        loadErr: null,
      };
    case corporateConstants.UPDATE_PRICE_SUCCESS:
      return {
        ...state,
        isLoad: false,
        loadErr: null,
        message: action.message,
      };
    case corporateConstants.UPDATE_PRICE_FAIL:
      return {
        ...state,
        isLoad: false,
        loadErr: action.error,
      };
    case corporateConstants.FLUSH_MESSAGE:
      return {
        ...state,
        isLoad: false,
        loadErr: null,
        message: null,
      };
    // Default
    default:
      return state;
  }
}
